import Orders from "../../components/Orders";

const MyAccount = () => {
    return(
            <Orders/>
    );
}


export default MyAccount;